<template>
    <span>
        <enquetelistagem></enquetelistagem>
    </span>
</template>

<script>
import Enquetelistagem from '@/components/Enquete-Listagem';

export default {
    name: 'cadenquetelistagem',
    components: {
        Enquetelistagem
    }
};
</script>